<template>
  <BuddySelectBar :interactable="true" @buddiesLoaded="onBuddiesLoaded"
                  @buddyChanged="onBuddySelected"></BuddySelectBar>
  <div class="container">
    <div class="row mt-3 mb-3">
      <InfoCard :info="tutorialInfo"></InfoCard>
    </div>

    <div class="row mt-3 mb-3">
      <QuestsContainer :selected-buddy="selectedBuddy"></QuestsContainer>
    </div>
  </div>
</template>

<script>
import QuestsContainer from "@/components/Quests/QuestsContainer";
import InfoCard from "@/components/Common/InfoCard";
import BuddySelectBar from "@/components/Common/BuddySelectBar";
import log from "@/utils/logger";

export default {
  name: "Activities",
  components: { QuestsContainer, InfoCard, BuddySelectBar },
  props: {},
  data()
  {
    return {
      tutorialInfo: {
        id: "tutorial_activities",
        title: "Activiteiten",
        body: "Gebruik de filter en/of zoekfunctie om de ideale activiteit te vinden voor je klas. Activiteiten die je al eens gespeeld hebt worden aangeduid met een vinkje."
      },
      selectedBuddy: null
    }
  },
  methods: {
    onBuddiesLoaded(buddies)
    {
      log.info("Buddies loaded for activity page: %o", buddies);
      if (buddies.length === 0)
      {
        this.$router.push({ name: "create-buddy", query: { referer: this.$route.fullPath } });
      }
    },
    onBuddySelected(buddy)
    {
      log.info("Buddy selected for activity page: %o", buddy);
      this.selectedBuddy = buddy;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>